import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../common/redux/store';
import { DEFAULT_SEARCH_VALUE } from './constant';
import { ICustomFieldSearchParams, ICustomFieldSearchState } from './interface';

const initialState: ICustomFieldSearchState = {
  searchValue: DEFAULT_SEARCH_VALUE,
  listIdDelete: [],
  showPopup: false,
};

export const listCustomFieldReducer = createSlice({
  name: 'listCustomField',
  initialState: initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<ICustomFieldSearchParams>) {
      state.searchValue = action.payload;
    },
    setListIdDelete(state, action: PayloadAction<number[]>) {
      state.listIdDelete = action.payload;
    },
    setShowPopup(state, action: PayloadAction<boolean>) {
      state.showPopup = action.payload;
    },
  },
});

export const { setSearchValue, setListIdDelete, setShowPopup } =
  listCustomFieldReducer.actions;

export const searchValue = (state: RootState) => state.listCustomField.searchValue;
export const listIdDelete = (state: RootState) => state.listCustomField.listIdDelete;
export const showPopup = (state: RootState) => state.listCustomField.showPopup;

export default listCustomFieldReducer.reducer;
